module.exports = __webpack_public_path__ + "img/contributions30On.296dd5ac.svg";